export enum Permission {
    ArticleCreate = 'article:create',
    ArticleExport = 'article:export',
    ArticleHardDelete = 'article:hard-delete',
    ArticleRestore = 'article:restore',
    ArticleSoftDelete = 'article:soft-delete',
    ArticleUpdate = 'article:update',
    ArticleView = 'article:view',
    ArticleViewAny = 'article:view-any',
    BankFeedView = 'finance:bank:feed:view',
    BankFeedUpdate = 'manage-bank-feeds',
    BankFeedExport = 'finance:bank:feed:export',
    CategoryCreate = 'category:create',
    CategoryExport = 'category:export',
    CategoryHardDelete = 'category:hard-delete',
    CategoryUpdate = 'category:update',
    CategoryView = 'category:view',
    CategoryViewAny = 'category:view-any',
    CloudflareAccountArchive = 'cloudflare:account:archive',
    CloudflareAccountCreate = 'cloudflare:account:create',
    CloudflareAccountDelete = 'cloudflare:account:delete',
    CloudflareAccountExport = 'cloudflare:account:export',
    CloudflareAccountRestore = 'cloudflare:account:restore',
    CloudflareAccountUpdate = 'cloudflare:account:update',
    CloudflareAccountView = 'cloudflare:account:view',
    CloudflareAccountViewAny = 'cloudflare:account:view:any',
    CloudflareDnsRecordArchive = 'cloudflare:dns:record:archive',
    CloudflareDnsRecordCreate = 'cloudflare:dns:record:create',
    CloudflareDnsRecordDelete = 'cloudflare:dns:record:delete',
    CloudflareDnsRecordExport = 'cloudflare:dns:record:export',
    CloudflareDnsRecordRestore = 'cloudflare:dns:record:restore',
    CloudflareDnsRecordUpdate = 'cloudflare:dns:record:update',
    CloudflareDnsRecordView = 'cloudflare:dns:record:view',
    CloudflareDnsRecordViewAny = 'cloudflare:dns:record:view:any',
    CloudflareServerArchive = 'cloudflare:server:archive',
    CloudflareServerCreate = 'cloudflare:server:create',
    CloudflareServerDelete = 'cloudflare:server:delete',
    CloudflareServerExport = 'cloudflare:server:export',
    CloudflareServerRestore = 'cloudflare:server:restore',
    CloudflareServerUpdate = 'cloudflare:server:update',
    CloudflareServerView = 'cloudflare:server:view',
    CloudflareServerViewAny = 'cloudflare:server:view:any',
    CloudflareZoneArchive = 'cloudflare:zone:archive',
    CloudflareZoneCreate = 'cloudflare:zone:create',
    CloudflareZoneDelete = 'cloudflare:zone:delete',
    CloudflareZoneExport = 'cloudflare:zone:export',
    CloudflareZoneRestore = 'cloudflare:zone:restore',
    CloudflareZoneUpdate = 'cloudflare:zone:update',
    CloudflareZoneView = 'cloudflare:zone:view',
    CloudflareZoneViewAny = 'cloudflare:zone:view:any',
    CollectorCreate = 'collector:create',
    CollectorExport = 'collector:export',
    CollectorHardDelete = 'collector:hard-delete',
    CollectorRestore = 'collector:restore',
    CollectorSoftDelete = 'collector:soft-delete',
    CollectorUpdate = 'collector:update',
    CollectorView = 'collector:view',
    CollectorViewAny = 'collector:view-any',
    CompanyAssetCreate = 'company:asset:create',
    CompanyAssetExport = 'company:asset:export',
    CompanyAssetHardDelete = 'company:asset:hard-delete',
    CompanyAssetRestore = 'company:asset:restore',
    CompanyAssetSoftDelete = 'company:asset:soft-delete',
    CompanyAssetUpdate = 'company:asset:update',
    CompanyAssetView = 'company:asset:view',
    CompanyAssetViewAny = 'company:asset:view-any',
    CompanyCreate = 'company:create',
    CompanyExport = 'company:export',
    CompanyHardDelete = 'company:hard-delete',
    CompanyRestore = 'company:restore',
    CompanySoftDelete = 'company:soft-delete',
    CompanyUpdate = 'company:update',
    CompanyView = 'company:view',
    CompanyViewAny = 'company:view-any',
    CompanyContactCreate = 'company:contact:create',
    CompanyContactExport = 'company:contact:export',
    CompanyContactHardDelete = 'company:contact:hard-delete',
    CompanyContactLogin = 'company:contact:login',
    CompanyContactRestore = 'company:contact:restore',
    CompanyContactSoftDelete = 'company:contact:soft-delete',
    CompanyContactUpdate = 'company:contact:update',
    CompanyContactView = 'company:contact:view',
    CompanyContactViewAny = 'company:contact:view-any',
    CompanyDisable = 'company:disable',
    CompanyEnable = 'company:enable',
    CompanySendEmail = 'company:send:email',
    CompanyServiceUsageCreate = 'company:service:usage:create',
    CompanyServiceUsageExport = 'company:service:usage:export',
    CompanyServiceUsageHardDelete = 'company:service:usage:hard-delete',
    CompanyServiceUsageRestore = 'company:service:usage:restore',
    CompanyServiceUsageSoftDelete = 'company:service:usage:soft-delete',
    CompanyServiceUsageUpdate = 'company:service:usage:update',
    CompanyServiceUsageView = 'company:service:usage:view',
    CompanyServiceUsageViewAny = 'company:service:usage:view-any',
    CompanyServiceCreate = 'company:service:create',
    CompanyServiceExport = 'company:service:export',
    CompanyServiceHardDelete = 'company:service:hard-delete',
    CompanyServiceRestore = 'company:service:restore',
    CompanyServiceSoftDelete = 'company:service:soft-delete',
    CompanyServiceUpdate = 'company:service:update',
    CompanyServiceView = 'company:service:view',
    CompanyServiceViewAny = 'company:service:view-any',
    CompanySiteCreate = 'company:site:create',
    CompanySiteExport = 'company:site:export',
    CompanySiteHardDelete = 'company:site:hard-delete',
    CompanySiteRestore = 'company:site:restore',
    CompanySiteSoftDelete = 'company:site:soft-delete',
    CompanySiteUpdate = 'company:site:update',
    CompanySiteView = 'company:site:view',
    CompanySiteViewAny = 'company:site:view-any',
    CompanyStatementExport = 'company:statement:export',
    CompanyStatementView = 'company:statement:view',
    CountryView = 'country:view',
    CountryViewAny = 'country:view-any',
    CountryCreate = 'country:create',
    CountryHardDelete = 'country:hard-delete',
    CountryRestore = 'country:restore',
    CountrySoftDelete = 'country:soft-delete',
    CountryUpdate = 'country:update',
    CreditCardView = 'company:credit:card:view',
    CreditCardUpdate = 'company:credit:card:update',
    CreditCardExport = 'company:credit:card:export',
    CreditCardExpiredSend = 'company:credit:card:expired:send',
    CreditCardRestored = 'company:credit:card:restored',
    CreditCardCreate = 'company:credit:card:create',
    DatumCreate = 'datum:create',
    DatumExport = 'datum:export',
    DatumHardDelete = 'datum:hard-delete',
    DatumRestore = 'datum:restore',
    DatumSoftDelete = 'datum:soft-delete',
    DatumUpdate = 'datum:update',
    DatumView = 'datum:view',
    DatumViewAny = 'datum:view-any',
    ManageDocumentTemplates = 'manage-document-templates',
    EventCreate = 'event:create',
    EventExport = 'event:export',
    EventHardDelete = 'event:hard-delete',
    EventRestore = 'event:restore',
    EventSoftDelete = 'event:soft-delete',
    EventUpdate = 'event:update',
    EventView = 'event:view',
    EventViewAny = 'event:view-any',
    FormArchive = 'form:archive',
    FormCreate = 'form:create',
    FormExport = 'form:export',
    FormDelete = 'form:delete',
    FormRestore = 'form:restore',
    FormUpdate = 'form:update',
    FormView = 'form:view',
    FormViewAny = 'form:view:any',
    InvoiceCreate = 'invoice:create',
    InvoiceExport = 'invoice:export',
    InvoiceHardDelete = 'invoice:hard-delete',
    InvoiceRestore = 'invoice:restore',
    InvoiceSend = 'invoice:send',
    InvoiceSoftDelete = 'invoice:soft-delete',
    InvoiceUpdate = 'invoice:update',
    InvoiceView = 'invoice:view',
    InvoiceViewAny = 'invoice:view-any',
    InvoiceItemCreate = 'invoice:item:create',
    InvoiceItemExport = 'invoice:item:export',
    InvoiceItemHardDelete = 'invoice:item:hard-delete',
    InvoiceItemRestore = 'invoice:item:restore',
    InvoiceItemSoftDelete = 'invoice:item:soft-delete',
    InvoiceItemUpdate = 'invoice:item:update',
    InvoiceItemView = 'invoice:item:view',
    InvoiceItemViewAny = 'invoice:item:view-any',
    KamailioAddressCreate = 'kamailio:address:create',
    KamailioAddressHardDelete = 'kamailio:address:hard-delete',
    KamailioAddressRestore = 'kamailio:address:restore',
    KamailioAddressSoftDelete = 'kamailio:address:soft-delete',
    KamailioAddressUpdate = 'kamailio:address:update',
    KamailioAddressView = 'kamailio:address:view',
    KamailioAddressViewAny = 'kamailio:address:view-any',
    KamailioGatewayCreate = 'kamailio:dynamic:route:gateway:create',
    KamailioGatewayHardDelete = 'kamailio:dynamic:route:gateway:hard-delete',
    KamailioGatewayRestore = 'kamailio:dynamic:route:gateway:restore',
    KamailioGatewaySoftDelete = 'kamailio:dynamic:route:gateway:soft-delete',
    KamailioGatewayUpdate = 'kamailio:dynamic:route:gateway:update',
    KamailioGatewayView = 'kamailio:dynamic:route:gateway:view',
    KamailioGatewayViewAny = 'kamailio:dynamic:route:gateway:view-any',
    KamailioRuleCreate = 'kamailio:dynamic:route:rule:create',
    KamailioRuleHardDelete = 'kamailio:dynamic:route:rule:hard-delete',
    KamailioRuleRestore = 'kamailio:dynamic:route:rule:restore',
    KamailioRuleSoftDelete = 'kamailio:dynamic:route:rule:soft-delete',
    KamailioRuleUpdate = 'kamailio:dynamic:route:rule:update',
    KamailioRuleView = 'kamailio:dynamic:route:rule:view',
    KamailioRuleViewAny = 'kamailio:dynamic:route:rule:view-any',
    KamailioServiceCreate = 'kamailio:service:create',
    KamailioServiceHardDelete = 'kamailio:service:hard-delete',
    KamailioServiceRestore = 'kamailio:service:restore',
    KamailioServiceSoftDelete = 'kamailio:service:soft-delete',
    KamailioServiceUpdate = 'kamailio:service:update',
    KamailioServiceView = 'kamailio:service:view',
    KamailioServiceViewAny = 'kamailio:service:view-any',
    KamailioTrustedCreate = 'kamailio:trusted:create',
    KamailioTrustedHardDelete = 'kamailio:trusted:hard-delete',
    KamailioTrustedRestore = 'kamailio:trusted:restore',
    KamailioTrustedSoftDelete = 'kamailio:trusted:soft-delete',
    KamailioTrustedUpdate = 'kamailio:trusted:update',
    KamailioTrustedView = 'kamailio:trusted:view',
    KamailioTrustedViewAny = 'kamailio:trusted:view-any',
    KamailioUsageCreate = 'kamailio:usage:create',
    KamailioUsageHardDelete = 'kamailio:usage:hard-delete',
    KamailioUsageRestore = 'kamailio:usage:restore',
    KamailioUsageSoftDelete = 'kamailio:usage:soft-delete',
    KamailioUsageUpdate = 'kamailio:usage:update',
    KamailioUsageView = 'kamailio:usage:view',
    KamailioUsageViewAny = 'kamailio:usage:view-any',
    LinkCreate = 'link:create',
    LinkExport = 'link:export',
    LinkHardDelete = 'link:hard-delete',
    LinkRestore = 'link:restore',
    LinkSoftDelete = 'link:soft-delete',
    LinkUpdate = 'link:update',
    LinkView = 'link:view',
    LinkViewAny = 'link:view-any',
    ManageCloudflare = 'manage-cloudflare',
    ManageBankFeedSource = 'manage-bank-feed-source',
    ManageCustomerSiteTypes = 'manage-customer-site-types',
    ManageCpanel = 'manage-cpanel',
    ManageCustomerTypes = 'manage-customer-types',
    ManageIPs = 'manage-ips',
    ManageFNN = 'manage-fnn',
    ManageGroups = 'manage-groups',
    ManageRSS = 'manage-rss',
    ManageEmailTemplates = 'manage-email-templates',
    ModuleCreate = 'module:create',
    ModuleHardDelete = 'module:hard-delete',
    ModuleRestore = 'module:restore',
    ModuleSoftDelete = 'module:soft-delete',
    ModuleUpdate = 'module:update',
    ModuleView = 'module:view',
    ModuleViewAny = 'module:view-any',
    NoteArchive = 'note:archive',
    NoteCreate = 'note:create',
    NoteDelete = 'note:delete',
    NoteExport = 'note:export',
    NoteRestore = 'note:restore',
    NoteUpdate = 'note:update',
    NoteView = 'note:view',
    NoteViewAny = 'note:view-any',
    PaymentCreate = 'payment:create',
    PaymentDelete = 'payment:hard-delete',
    PaymentExport = 'payment:export',
    PaymentRestore = 'payment:restore',
    PaymentArchive = 'payment:soft-delete',
    PaymentUpdate = 'payment:update',
    PaymentView = 'payment:view',
    PaymentViewAny = 'payment:view-any',
    PaymentItemCreate = 'payment:item:create',
    PaymentItemDelete = 'payment:item:delete',
    PaymentItemExport = 'payment:item:export',
    PaymentItemRestore = 'payment:item:restore',
    PaymentItemArchive = 'payment:item:archive',
    PaymentItemUpdate = 'payment:item:update',
    PaymentItemView = 'payment:item:view',
    PaymentItemViewAny = 'payment:item:view-any',
    ProductCreate = 'product:create',
    ProductExport = 'product:export',
    ProductDelete = 'product:hard-delete',
    ProductUpdate = 'product:update',
    ProductView = 'product:view',
    ProductViewAny = 'product:view-any',
    RadiusAccountArchive = 'radius:account:archive',
    RadiusAccountCreate = 'radius:account:create',
    RadiusAccountDelete = 'radius:account:delete',
    RadiusAccountExport = 'radius:account:export',
    RadiusAccountRestore = 'radius:account:restore',
    RadiusAccountUpdate = 'radius:account:update',
    RadiusAccountView = 'radius:account:view',
    RadiusAccountViewAny = 'radius:account:view-any',
    RadiusLoginHistoryArchive = 'radius:login:history:archive',
    RadiusLoginHistoryCreate = 'radius:login:history:create',
    RadiusLoginHistoryDelete = 'radius:login:history:delete',
    RadiusLoginHistoryExport = 'radius:login:history:export',
    RadiusLoginHistoryRestore = 'radius:login:history:restore',
    RadiusLoginHistoryUpdate = 'radius:login:history:update',
    RadiusLoginHistoryView = 'radius:login:history:view',
    RadiusLoginHistoryViewAny = 'radius:login:history:view-any',
    RadiusReplyArchive = 'radius:reply:archive',
    RadiusReplyCreate = 'radius:reply:create',
    RadiusReplyDelete = 'radius:reply:delete',
    RadiusReplyExport = 'radius:reply:export',
    RadiusReplyRestore = 'radius:reply:restore',
    RadiusReplyUpdate = 'radius:reply:update',
    RadiusReplyView = 'radius:reply:view',
    RadiusReplyViewAny = 'radius:reply:view-any',
    RadiusServerArchive = 'radius:server:archive',
    RadiusServerCreate = 'radius:server:create',
    RadiusServerDelete = 'radius:server:delete',
    RadiusServerExport = 'radius:server:export',
    RadiusServerRestore = 'radius:server:restore',
    RadiusServerUpdate = 'radius:server:update',
    RadiusServerView = 'radius:server:view',
    RadiusServerViewAny = 'radius:server:view-any',
    RadiusUserArchive = 'radius:user:archive',
    RadiusUserCreate = 'radius:user:create',
    RadiusUserDelete = 'radius:user:delete',
    RadiusUserExport = 'radius:user:export',
    RadiusUserRestore = 'radius:user:restore',
    RadiusUserUpdate = 'radius:user:update',
    RadiusUserView = 'radius:user:view',
    RadiusUserViewAny = 'radius:user:view-any',
    RateCreate = 'rate:create',
    RateExport = 'rate:export',
    RateHardDelete = 'rate:hard-delete',
    RateRestore = 'rate:restore',
    RateSoftDelete = 'rate:soft-delete',
    RateUpdate = 'rate:update',
    RateView = 'rate:view',
    RateViewAny = 'rate:view-any',
    ReceiptCreate = 'receipt:create',
    ReceiptHardDelete = 'receipt:hard-delete',
    ReceiptRestore = 'receipt:restore',
    ReceiptSend = 'receipt:send',
    ReceiptSoftDelete = 'receipt:soft-delete',
    ReceiptUpdate = 'receipt:update',
    ReceiptView = 'receipt:view',
    ReceiptViewAny = 'receipt:view-any',
    RegionCreate = 'region:create',
    RegionExport = 'region:export',
    RegionHardDelete = 'region:hard-delete',
    RegionRestore = 'region:restore',
    RegionSoftDelete = 'region:soft-delete',
    RegionUpdate = 'region:update',
    RegionView = 'region:view',
    RegionViewAny = 'region:view-any',
    RoleCreate = 'role:create',
    RoleHardDelete = 'role:hard-delete',
    RoleRestore = 'role:restore',
    RoleSoftDelete = 'role:soft-delete',
    RoleUpdate = 'role:update',
    RoleView = 'role:view',
    RoleViewAny = 'role:view-any',
    SecretCreate = 'secret:create',
    SecretExport = 'secret:export',
    SecretHardDelete = 'secret:hard-delete',
    SecretRestore = 'secret:restore',
    SecretSoftDelete = 'secret:soft-delete',
    SecretUpdate = 'secret:update',
    SecretView = 'secret:view',
    SecretViewAny = 'secret:view-any',
    SendEmail = 'send:email',
    SentEmailArchive = 'sent:email:archive',
    SentEmailCreate = 'sent:email:create',
    SentEmailExport = 'sent:email:export',
    SentEmailDelete = 'sent:email:delete',
    SentEmailRestore = 'sent:email:restore',
    SentEmailUpdate = 'sent:email:update',
    SentEmailView = 'sent:email:view',
    SentEmailViewAny = 'sent:email:view:any',
    StaffViewAny = 'staff:view-any',
    StaffCreate = 'staff:create',
    StaffUpdate = 'staff:update',
    StaffRestore = 'staff:restore',
    StaffSoftDelete = 'staff:soft-delete',
    StaffHardDelete = 'staff:hard-delete',
    StaffExport = 'staff:export',
    SMSGlobalServerCreate = 'sms-global:server:create',
    SMSGlobalServerDelete = 'sms-global:server:delete',
    SMSGLobalServerUpdate = 'sms-global:server:update',
    SMSGlobalServerView = 'sms-global:server:view',
    SMSGlobalServerViewAny = 'sms-global:server:view:any',
    SMSGlobalServerArchive = 'sms-global:server:archive',
    SMSGlobalServerRestore = 'sms-global:server:restore',
    SMSGlobalServerExport = 'sms-global:server:export',
    SMSGlobalSMSArchive = 'sms-global:sms:archive',
    SMSGlobalSMSCreate = 'sms-global:sms:create',
    SMSGlobalSMSDelete = 'sms-global:sms:delete',
    SMSGlobalSMSExport = 'sms-global:sms:export',
    SMSGlobalSMSRestore = 'sms-global:sms:restore',
    SMSGlobalSMSUpdate = 'sms-global:sms:update',
    SMSGlobalSMSView = 'sms-global:sms:view',
    SMSGlobalSMSViewAny = 'sms-global:sms:view:any',
    TariffCreate = 'tariff:create',
    TariffHardDelete = 'tariff:hard-delete',
    TariffRestore = 'tariff:restore',
    TariffSoftDelete = 'tariff:soft-delete',
    TariffUpdate = 'tariff:update',
    TariffView = 'tariff:view',
    TariffViewAny = 'tariff:view-any',
    TariffRegexCreate = 'tariff:regex:create',
    TariffRegexHardDelete = 'tariff:regex:hard-delete',
    TariffRegexRestore = 'tariff:regex:restore',
    TariffRegexSoftDelete = 'tariff:regex:soft-delete',
    TariffRegexUpdate = 'tariff:regex:update',
    TariffRegexView = 'tariff:regex:view',
    TariffRegexViewAny = 'tariff:regex:view-any',
    TenantCreate = 'tenant:create',
    TenantExport = 'tenant:export',
    TenantDelete = 'tenant:hard-delete',
    TenantRestore = 'tenant:restore',
    TenantArchive = 'tenant:soft-delete',
    TenantUpdate = 'tenant:update',
    TenantView = 'tenant:view',
    TenantViewAny = 'tenant:view-any',
    TicketCreate = 'ticket:create',
    TicketExport = 'ticket:export',
    TicketDelete = 'ticket:hard-delete',
    TicketRestore = 'ticket:restore',
    TicketArchive = 'ticket:soft-delete',
    TicketUpdate = 'ticket:update',
    TicketView = 'ticket:view',
    TicketViewAny = 'ticket:view-any',
    TicketTemplateCreate = 'ticket:template:create',
    TicketTemplateView = 'ticket:template:view',
    TicketTemplateViewAny = 'ticket:template:view-any',
    TicketTemplateUpdate = 'ticket:template:update',
    TicketTemplateDelete = 'ticket:template:hard-delete',
    TicketTemplateExport = 'ticket:template:export',
    TicketTypeCreate = 'ticket:type:create',
    TicketTypeView = 'ticket:type:view',
    TicketTypeViewAny = 'ticket:type:view-any',
    TicketTypeUpdate = 'ticket:type:update',
    TicketTypeDelete = 'ticket:type:hard-delete',
    TicketTypeExport = 'ticket:type:export',
    TicketPriorityView = 'ticket:priority:view',
    TicketPriorityViewAny = 'ticket:priority:view-any',
    TicketPriorityUpdate = 'ticket:priority:update',
    TicketPriorityDelete = 'ticket:priority:hard-delete',
    TicketResourceDelete = 'ticket:resource:hard-delete',
    TicketDepartmentCreate = 'ticket:department:create',
    TicketDepartmentView = 'ticket:department:view',
    TicketDepartmentViewAny = 'ticket:department:view-any',
    TicketDepartmentUpdate = 'ticket:department:update',
    TicketDepartmentDelete = 'ticket:department:hard-delete',
    TicketDepartmentExport = 'ticket:department:export',
    LocationCreate = 'location:create',
    LocationExport = 'location:export',
    LocationDelete = 'location:hard-delete',
    LocationView = 'location:view',
    LocationViewAny = 'location:view-any',
    VocusNBNServiceArchive = 'vocus:mobile:server:soft-delete',
    VocusNBNServiceCreate = 'vocus:mobile:server:create',
    VocusNBNServiceDelete = 'vocus:mobile:server:hard-delete',
    VocusNBNServiceRestore = 'vocus:mobile:server:restore',
    VocusNBNServiceUpdate = 'vocus:mobile:server:update',
    VocusNBNServiceView = 'vocus:mobile:server:view',
    VocusNBNServiceViewAny = 'vocus:mobile:server:view-any',
    VocusMobileServerArchive = 'vocus:mobile:server:soft-delete',
    VocusMobileServerCreate = 'vocus:mobile:server:create',
    VocusMobileServerDelete = 'vocus:mobile:server:hard-delete',
    VocusMobileServerRestore = 'vocus:mobile:server:restore',
    VocusMobileServerUpdate = 'vocus:mobile:server:update',
    VocusMobileServerView = 'vocus:mobile:server:view',
    VocusMobileServerViewAny = 'vocus:mobile:server:view-any',
    VocusMobileArchive = 'vocus:mobile:archive',
    VocusMobileCreate = 'vocus:mobile:create',
    VocusMobileDelete = 'vocus:mobile:delete',
    VocusMobileExport = 'vocus:mobile:export',
    VocusMobileRestore = 'vocus:mobile:restore',
    VocusMobileUpdate = 'vocus:mobile:update',
    VocusMobileView = 'vocus:mobile:view',
    VocusMobileViewAny = 'vocus:mobile:view:any',
    VocusMobileUsageArchive = 'vocus:mobile:usage:archive',
    VocusMobileUsageCreate = 'vocus:mobile:usage:create',
    VocusMobileUsageDelete = 'vocus:mobile:usage:delete',
    VocusMobileUsageExport = 'vocus:mobile:usage:export',
    VocusMobileUsageRestore = 'vocus:mobile:usage:restore',
    VocusMobileUsageUpdate = 'vocus:mobile:usage:update',
    VocusMobileUsageView = 'vocus:mobile:usage:view',
    VocusMobileUsageViewAny = 'vocus:mobile:usage:view:any',
}
